import { connect } from 'react-redux'
import Styles from './CountriesPage.module.css'
import { Colors } from 'Theme'
import { CountriesPageTabs } from 'Containers'
import React, { useEffect, useRef, useState } from 'react'
import CountriesSelectors from 'Stores/Country/Selectors'
import CountriesActions from 'Stores/Country/Actions'
import AuthSelectors from 'Stores/Auth/Selectors'
import { IFButton, IFFilter, IFModal, IFSkeleton } from 'Components'
import RequestState from 'Enums/RequestState'
import InfinityEnums from 'Enums/InfinityEnums'
import { useTranslation } from 'react-i18next'
import Scrollbars from 'react-custom-scrollbars'
import { CountriesList } from 'Containers'
import LoadingBar from 'react-top-loading-bar'
import AddCountryForm from './AddCountryForm'
import { useLocation } from 'react-router-dom'
import { Actions, Subjects } from 'Enums/permissionKeys'

const CountriesPage = ({
  CountriesCount,
  fetchCountriesList,
  countriesFilters,
  editingAdminRole,
  fetchCountriesListRequestState,
  setCountriesFilter,
  clearCountriesFilter,
  clearCountries,
  addCountryRequestState,
  addCountry,
  fetchCountriesListCount,
}) => {
  const { t } = useTranslation()
  const countriesFilterRef = useRef(null)
  const tablesRef = useRef(null)
  const [tablesHeight, setTablesHeight] = React.useState(0)
  const showCountryDialogHandler = useRef()
  const location = useLocation()
  useEffect(() => {
    if (location.state?.refresh) {
      setFetchListLoadingState(true)
      clearCountries()
      clearCountriesFilter()
      countriesFilterRef?.current?.clearFilter()
      setSelectedTabIndex(0)
    }
  }, [location.state?.refresh])

  useEffect(() => {
    return () => {
      setFetchListLoadingState(true)
      clearCountries()
      clearCountriesFilter()
      countriesFilterRef?.current?.clearFilter()
      setSelectedTabIndex(0)
    }
  }, [])
  useEffect(() => {
    const handleResize = (entries) => {
      if (entries[0]) {
        const { height } = entries[0].contentRect
        setTablesHeight(height)
      }
    }

    const resizeObserver = new ResizeObserver(handleResize)

    if (tablesRef.current) {
      resizeObserver.observe(tablesRef.current)
    }

    return () => {
      if (tablesRef.current) {
        resizeObserver.unobserve(tablesRef.current)
      }
    }
  }, [])
  const [fetchListLoadingState, setFetchListLoadingState] = useState(true)
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  const handleTabChange = (newValue) => {
    setSelectedTabIndex(newValue)
  }
  useEffect(() => {
    fetchCountriesListCount(countriesFilters)
  }, [countriesFilters])
  useEffect(() => {
    fetchCountriesList(countriesFilters, 0)
    fetchCountriesListCount(countriesFilters)
  }, [countriesFilters])

  const handleCountriesFilterChange = (newFilter) => {
    clearCountries()
    fetchCountriesList(newFilter, 0)
    setCountriesFilter(newFilter)
  }

  const [progress, setProgress] = useState(0)
  useEffect(() => {
    if (fetchListLoadingState) {
      if (
        fetchCountriesListRequestState === RequestState.LOADING &&
        progress === 0
      ) {
        setProgress(progress + 10)
      }

      if (fetchCountriesListRequestState === RequestState.SUCCEEDED) {
        setProgress(100)
        setFetchListLoadingState(false)
      }

      if (
        fetchCountriesListRequestState !== RequestState.LOADING &&
        fetchCountriesListRequestState !== RequestState.UNINITIALIZED &&
        fetchCountriesListRequestState !== RequestState.SUCCEEDED
      )
        setProgress(100)
    }
  }, [fetchCountriesListRequestState])
  useEffect(() => {
    if (addCountryRequestState === RequestState.SUCCEEDED)
      showCountryDialogHandler.current.dismiss()
  }, [addCountryRequestState])
  const onSubmitCountryFormHandler = (country) => {
    addCountry(country)
  }
  return (
    <div className={Styles.WrapperContainer}>
      <div>
        <LoadingBar
          color={Colors.primary}
          progress={progress}
          onLoaderFinished={() => setProgress(0)}
        />
      </div>
      <div
        className={Styles.TopContainer}
        style={{
          backgroundColor: Colors.white,
          borderColor: Colors.UserPageBackgroundContainer,
        }}
      >
        <div className={Styles.UserDataContainer}>
          <div className={Styles.InnerContainer}>
            <div className={Styles.TabButtonDiv}>
              <CountriesPageTabs
                onValueChange={handleTabChange}
                initialIndex={0}
                isLoading={
                  fetchListLoadingState &&
                  (fetchCountriesListRequestState === RequestState.LOADING ||
                    fetchCountriesListRequestState ===
                      RequestState.UNINITIALIZED)
                }
                CountriesCount={CountriesCount}
                fetchListRequestState={fetchCountriesListRequestState}
              />
              {editingAdminRole?.can(Actions.EDIT, Subjects.COUNTRIES) && (
                <div>
                  {fetchListLoadingState &&
                  fetchCountriesListRequestState === RequestState.LOADING ? (
                    <IFSkeleton variant="text" width="100px" />
                  ) : (
                    <>
                      {selectedTabIndex === 0 && (
                        <IFButton
                          size="sm"
                          color={Colors.primary}
                          isFill={false}
                          isLoading={false}
                          className={Styles.CreateButton}
                          onClick={() => {
                            showCountryDialogHandler.current.show()
                          }}
                          text={t('CountriesPage.Add')}
                          loadSkeleton={
                            fetchCountriesListRequestState ===
                              RequestState.LOADING && fetchListLoadingState
                          }
                        />
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
            <div className={Styles.Filter}>
              {selectedTabIndex === 0 && (
                <IFFilter
                  ref={countriesFilterRef}
                  onFilterChange={(newFilter) => {
                    handleCountriesFilterChange(newFilter)
                  }}
                  isLoading={
                    fetchCountriesListRequestState === RequestState.LOADING &&
                    fetchListLoadingState
                  }
                  filters={countriesFilters}
                  textFieldPlaceholder={t(
                    'CountriesPage.CountriesFilterPlaceholder',
                  )}
                />
              )}
            </div>
          </div>
          <Scrollbars autoHide>
            <div className={Styles.Tables} ref={tablesRef}>
              {selectedTabIndex === 0 && (
                <CountriesList tablesHeight={tablesHeight} />
              )}
            </div>
          </Scrollbars>
        </div>
      </div>
      <IFModal
        title={t('CountriesPage.AddNewCountry')}
        open={false}
        ref={showCountryDialogHandler}
      >
        <AddCountryForm
          onSubmitForm={(values) => onSubmitCountryFormHandler(values)}
        />
      </IFModal>
    </div>
  )
}
function mapDispatchToProps(dispatch) {
  return {
    fetchCountriesList: (filter, offset, shouldShowError) =>
      dispatch(
        CountriesActions.fetchCountriesList(filter, offset, shouldShowError),
      ),
    fetchCountriesListCount: (filter) =>
      dispatch(CountriesActions.fetchCountriesListCount(filter)),
    setCountriesFilter: (newFilter) =>
      dispatch(CountriesActions.setCountriesFilter(newFilter)),
    clearCountriesFilter: () =>
      dispatch(CountriesActions.clearCountriesFilter()),
    clearCountries: () => dispatch(CountriesActions.clearCountries()),
    addCountry: (country) => dispatch(CountriesActions.addCountry(country)),
  }
}
const mapStateToProps = (state) => ({
  CountriesCount: CountriesSelectors.getCountriesCount(state),
  countriesFilters: CountriesSelectors.getCountriesFilters(state),
  fetchCountriesListRequestState:
    CountriesSelectors.getFetchCountriesListRequestState(state),
  editingAdminRole: AuthSelectors.getEditingAdminRole(state),
  addCountryRequestState: CountriesSelectors.getAddCountryRequestState(state),
})
export default connect(mapStateToProps, mapDispatchToProps)(CountriesPage)
